import type { SignatureUser } from '../types';

export function isPendingSignatureAvailable(user: SignatureUser): boolean {
	return !user.connectedToFacebook && !user.passwordSet;
}
